export default `mutation CreateOrder($exampleCreateOrderInput: CreateOrderMutationInput!) {
  createOrder(input: $exampleCreateOrderInput) {
    created
    error
  }
}`;
